<template lang="html">
  <b-container class="p-0">
      <b-row no-gutters align-h="center" class="pb-3">
        <b-col md = "auto" class= "mr-1">
          <b-button size="sm" v-b-modal.modal-1 variant="primary" :disabled="dis_start_time" @click="save_start_time">
              Aloita työpäivä
          </b-button>
        </b-col>
        <b-col md = "auto">
          <b-button size="sm" variant="success" @click="$emit('End_day')">
              Päätä työpäivä
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="dis_start_time">
        <b-col>
          <span v-b-tooltip.hover><h5 v-b-modal.modal-4>Työpäivä alkoi: {{format_start(timer_tasks[0].start_time)}}</h5></span>
        </b-col>
        <b-col>
          <span v-b-tooltip.hover><h5>Työaika: {{work_time}}</h5></span>
        </b-col>
      </b-row>
      <b-row align-h="between" no-gutters v-if="dis_start_time">
        <b-col md = "auto">
          <b-button size="sm" variant="warning" v-b-modal.modal-1>
              Uus tehtävän
          </b-button>
        </b-col>
        <b-col md = "auto">
          <b-button size="sm" variant="success" @click="$emit('add_lounas', 'lounas')">
              Lounas
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="dis_start_time">
        <b-col>
          <b-progress height="4px" :value="progress" class="m-1"></b-progress>
        </b-col>
      </b-row>
  </b-container>

</template>

<script>
import moment from 'moment';

export default {
  props: ["dis_start_time", "timer_tasks"],
  data(){
    return {
      interval:null,
      time:0,
      work_time:0,
      progress: 0,
      work_hours: moment("08:00:00", "HH:mm:ss").diff(moment("00:00:00","HH:mm:ss")),
    }
  },
  methods: {
    save_start_time(){
      this.$emit("empty_list");
    },
    updateTime() {
      this.time = moment(new Date).format("HH:mm");
    },
    updateWorkTime() {
      const work_time = moment(new Date).diff(moment(this.timer_tasks[0].start_time))
      this.work_time = moment.utc(work_time).format("HH:mm")
      this.progress = (work_time / this.work_hours) * 100
    },
    format_start(time) {
       return moment(time).format('HH:mm');
     },
  },
  mounted() {
      this.interval = setInterval(() => {
        this.updateTime();
        if(this.dis_start_time){
          this.updateWorkTime();
        }
      },1000);

      this.updateTime();
    },
}
</script>

<style lang="css" scoped>
</style>
